import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Breadcrumbs } from './Breadcrumbs';
import type { BackofficeUserType } from '@/backoffice/config/theme';
import { useBackofficeSession } from '@/backoffice/hooks/useBackofficeSession';

interface DashboardLayoutProps {
  userType: BackofficeUserType;
  title?: string;
  children: ReactNode;
  userName?: string;
  userAvatar?: string;
  showSearch?: boolean;
  breadcrumbs?: { label: string; path?: string }[];
}

export function DashboardLayout({
  userType,
  title,
  children,
  userName: userNameProp,
  userAvatar,
  showSearch = false,
  breadcrumbs = [],
}: DashboardLayoutProps) {
  const session = useBackofficeSession(userType);
  const userName = userNameProp ?? session.userName;

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar
        userType={userType}
        userName={userName}
        userAvatar={userAvatar}
      />
      <div className="flex-1 flex flex-col min-h-screen">
        <Header
          userType={userType}
          title={title}
          userName={userName}
          userAvatar={userAvatar}
          showSearch={showSearch}
        />
        <main className="flex-1 p-4 lg:p-6">
          {breadcrumbs.length > 0 && (
            <div className="mb-4">
              <Breadcrumbs items={breadcrumbs} userType={userType} />
            </div>
          )}
          {children}
        </main>
      </div>
    </div>
  );
}

export type { BackofficeUserType };
